import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import DashboardCard from '../shared/DashboardCard';
import MyTableCell from '../material-ui/adaptive/MyTableCell';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import useColor from '../../hooks/site/useColor';
import ShowContainer from '../material-ui/ShowContainer';
import { API_INFO } from '../../api/info';
import MyTableZeroPCell from '../material-ui/adaptive/MyTableZeroPCell';
import { useAppSelector } from '../../store';
import TypographyText from '../material-ui/table/TypographyText';
import CusButton from '../material-ui/CusButton';
import { Link } from 'react-router';
import LoaderContainer from '../material-ui/loader_container/LoaderContainer';
import BoxGrayContainer from '../material-ui/BoxGrayContainer';

export default function BalanceCrypto({ casinoId }) {
  const { t } = useTranslation();
  const { primary, action } = useColor();
  const primaryColor = primary.main;
  const casinos = useAppSelector((state) => state.user.info.casino) || [];

  const [cryptoBalance, setCryptoBalance] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState({ prevId: null, loading: false });
  const [errorMerchant, setErrorMerchant] = useState(false);
  const [casinoName, setCasinoName] = useState('');
  const [merchantId, setMerchantId] = useState('');

  const getCryptoWalletList = () => {
    if (btnDisabled) return;
    setBtnDisabled(true);
    API_INFO.cryptogate
      .list({ casinoId })
      .then((e) => {
        const data = e.data;
        const walletList = data.list;
        setCryptoBalance(Object.values(walletList).sort((a, b) => b.usdValue - a.usdValue));
        setMerchantId(data.merchantId);
      })
      .catch((e) => {
        const dataError = e.dataError;
        if (dataError == 618) setErrorMerchant(true);
        setCryptoBalance([]);
      })
      .finally(() => {
        const casinoName = casinos.find((el) => el.id == casinoId).casinoName;
        setCasinoName(casinoName);
        setBtnDisabled(false);
        setLoading({ prevId: casinoId, loading: false });
      });
  };

  useEffect(() => {
    setLoading((prev) =>
      prev.prevId == casinoId
        ? { prevId: casinoId, loading: false }
        : { prevId: casinoId, loading: true }
    );
    getCryptoWalletList();
  }, [casinoId]);

  const updateClick = () => {
    getCryptoWalletList();
  };

  const PlugBalanceCrypto = () => {
    if (errorMerchant)
      return (
        <BoxGrayContainer>
          <Stack gap={3}>
            <Stack gap={1}>
              <Typography variant="h5">{t('Crypto gateway is not configured')}</Typography>
              <Typography variant="body1">
                {t('To display your balance, you need to configure a crypto gateway.')}
              </Typography>
            </Stack>
            <CusButton
              text={`${t('Configure for casino')} ${casinoName}`}
              LinkComponent={Link}
              to={'/casino/payment/gateway/' + casinoId}
              sx={{ px: 3 }}
              variant="contained"
            />
          </Stack>
        </BoxGrayContainer>
      );
  };

  return (
    <LoaderContainer loader={loading.loading} boxSx={{ height: '100%' }}>
      <ShowContainer condition={cryptoBalance.length} plug={<PlugBalanceCrypto />}>
        <DashboardCard
          title={
            <Stack gap={0.5}>
              <Typography variant="h6">
                {t('Crypto gateway balance')} ({casinoName})
              </Typography>
              <Typography component={'span'} mt={1}>
                Merchant Id <TypographyText isCopy={merchantId}>{merchantId}</TypographyText>
              </Typography>
            </Stack>
          }
          action={
            <Stack title={t('Update balances')} onClick={updateClick} style={{ cursor: 'pointer' }}>
              <IconRefresh color={btnDisabled ? action.disabledBackground : primaryColor} />
            </Stack>
          }>
          <TableContainer>
            <Table sx={{ whiteSpace: 'nowrap' }}>
              <TableHead>
                <TableRow>
                  <MyTableZeroPCell></MyTableZeroPCell>
                  <MyTableZeroPCell></MyTableZeroPCell>
                  <MyTableZeroPCell></MyTableZeroPCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cryptoBalance.map((cryptoInfo) => (
                  <TableRow key={cryptoInfo.ticker}>
                    <MyTableCell>
                      <Stack display={'flex'} direction={'row'} gap={0.5}>
                        <Typography>{cryptoInfo.name}</Typography>
                        <Typography fontSize={12} color="textDisabled">
                          ({cryptoInfo.walletId})
                        </Typography>
                      </Stack>
                    </MyTableCell>
                    <MyTableCell>
                      <Stack display={'flex'} direction={'row'} gap={0.5} justifyContent={'end'}>
                        <Typography>
                          {+Number(cryptoInfo.value).toFixed(cryptoInfo.precision ?? 4)}
                        </Typography>
                        <Typography textTransform={'uppercase'}>{cryptoInfo.ticker}</Typography>
                      </Stack>
                    </MyTableCell>
                    <MyTableCell type="numeric" fontSize={14}>
                      {+Number(cryptoInfo.usdValue).toFixed(2)} USD
                    </MyTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DashboardCard>
      </ShowContainer>
    </LoaderContainer>
  );
}
